<template>
  <div>
    <div style="color: #fccc66">乡镇种植面积占比</div>
    <div id="rown-ratio-container" style="height: 360px"></div>
  </div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: 130,
            center: ['50%', '40%'],
            data: [
              { name: '水湖镇', value: 7000 },
              { name: '下塘镇', value: 201 },
              { name: '陶楼镇', value: 472 },
              { name: '庄墓镇', value: 768 },
              { name: '吴山镇', value: 641 },
              { name: '杨庙镇', value: 1626 },
              { name: '造甲乡', value: 243 },
              { name: '义井镇', value: 936 },
              { name: '杜集镇', value: 604 },
              { name: '左店镇', value: 4000 },
              { name: '罗塘乡', value: 5000 },
              { name: '朱巷镇', value: 394 },
              { name: '双凤开发区', value: 206 },
            ],
            insideLabel: {
              show: true,
            },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('rown-ratio-container')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/summary-zone/town-ratio.vue